/**
 * Easify Live Preview Relocator
 *
 * Easify Product Options injecte par defaut son canvas live preview comme enfant
 * direct du <slider-component> de la galerie produit. Sur le theme Sense modifie
 * (galerie 2 colonnes desktop + swipe mobile), ce comportement cause des bugs
 * d'affichage.
 *
 * Ce script deplace le portal Easify (qui contient le canvas live preview)
 * depuis la galerie vers la zone dediee #custom-easify-preview-wrapper, juste
 * sous les options de personnalisation. La galerie produit reste 100% intacte.
 *
 * Le MutationObserver reste actif en continu pour re-deplacer le portal au cas
 * ou Easify le re-injecte dans la galerie (ex: suite a un changement de variant
 * ou un re-render React).
 *
 * Charge uniquement sur les templates produits personnalisables
 * (voir sections/main-product.liquid : assign perso_templates).
 *
 * Version: 2026-04-29-r2
 */
(function () {
  'use strict';

  var TARGET_WRAPPER_ID = 'custom-easify-preview-wrapper';

  function findLivePreviewPortal() {
    var portals = document.querySelectorAll('.easify.portal');
    for (var i = 0; i < portals.length; i++) {
      if (portals[i].querySelector('canvas')) {
        return portals[i];
      }
    }
    return null;
  }

  function relocateEasifyPreview() {
    var wrapper = document.getElementById(TARGET_WRAPPER_ID);
    if (!wrapper) return false;

    var portal = findLivePreviewPortal();
    if (!portal) return false;
    if (portal.parentElement === wrapper) return true;

    wrapper.appendChild(portal);
    wrapper.setAttribute('data-easify-relocated', 'true');

    forceShowPreview(portal);
    return true;
  }

  function forceShowPreview(portal) {
    var livePreview = portal.querySelector('.po-livePreview-root');
    if (livePreview) {
      livePreview.style.setProperty('display', 'flex', 'important');
      livePreview.style.setProperty('visibility', 'visible', 'important');
      livePreview.style.setProperty('opacity', '1', 'important');
    }
  }

  function init() {
    relocateEasifyPreview();

    var observer = new MutationObserver(function () {
      relocateEasifyPreview();

      var wrapper = document.getElementById(TARGET_WRAPPER_ID);
      if (wrapper) {
        var portal = wrapper.querySelector('.easify.portal');
        if (portal) forceShowPreview(portal);
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
